// setting default content to fill in placeholder data for fields not filled out
function SoftwareLpModel({
  hero: {
    hero_src = '',
    hero_alt = '',
    hero_title = '',
    hero_description = '',
  },
}) {
  return {
    hero: {
      hero_src,
      hero_alt,
      hero_title,
      hero_description,
    },
  };
}

export default SoftwareLpModel;
